export default __webpack_public_path__ + "static/media/1_0160.da9f2b47.webp";